export enum GeoSystemTypes {
	Metric = 'metric',
	Imperial = 'imperial',
}
